import React from 'react';
import equals from 'deep-equal';
import pickAll from 'ramda/src/pickAll.js';

function isClassComponent ( component ) {
    return (
        typeof component === 'function' &&
        !!component.prototype.isReactComponent
    )
}

function isFunctionComponent ( component ) {
    return (
        typeof component === 'function' &&
        String( component ).includes( 'return React.createElement' )
    )
}

export function isReactComponent ( component ) {
    return (
        isClassComponent( component ) ||
        isFunctionComponent( component )
    )
}

export function isElement ( element ) {
    return React.isValidElement( element );
}

export function isDOMTypeElement ( element ) {
    return isElement( element ) && typeof element.type === 'string';
}

export function isCompositeTypeElement ( element ) {
    return isElement( element ) && typeof element.type === 'function';
}

export const arePropsEqual = compareProps =>
    ( props, nextProps ) =>
        equals( pickAll( compareProps, props ), pickAll( compareProps, nextProps ) )

/**
 * Generates a list of steps for display by the steps component.
 *
 * This function returns a function that accepts a step object and returns
 * the object with extra properties.
 *
 * @param {Object} route
 * @returns {Function}
 */
export function generateStepsList ( {route} ) {
    const routeParams = route.params
    const routeParamKeys = Object.keys( routeParams )
    // Swap out any dynamic routes with their param values so "/portfolio/:portfolioId" becomes "/portfolio/1"
    const replaceParams = ( path, param ) => path.replace( `:${param}`, routeParams[param] );

    return ( {path, label} ) => {
        const routePath = routeParamKeys.length ? routeParamKeys.reduce( replaceParams, path ) : path;
        const pattern = new RegExp( `${path}$` );
        const active = pattern.test( route.pathname );

        return {
            path: routePath,
            active,
            label
        };
    }
}
